A code classifying the primary method of payment for a position.

Currently, three codes are defined:

- `Hourly` employment is paid for the number of hours worked.

- `Salaried` employment is paid on a monthly or annual basis.

- `SalariedPlusCommission` employment is paid on an annual basis plus a results-based commission.

This field should be provided. If it is omitted, or if the supplied `interval` and `basis` are not one of the supported combinations above, the salary will not be included on the job ad.

When provided, it must correspond to `SyncPositions_RemunerationRangeInput.interval`:

- When `SyncPositions_RemunerationRangeInput.interval` equals `Hour`, the `basis` must be `Hourly`.

- When `SyncPositions_RemunerationRangeInput.interval` equals `Month`, the `basis` must be `Salaried`.

- When `SyncPositions_RemunerationRangeInput.interval` equals `Year`, the `basis` must be `Salaried` or `SalariedPlusCommission`.
